import type { NamespaceTester } from "src/lib/i18next/types.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import { getResourceI18nNamespace } from "src/system/getResourceI18nNamespace.ts";
import { getAllModulesIds } from "src/system/getAllModulesIds.ts";

const isResourceTranslation = (ns: string) => (resource: string) => {
  const namespace = getResourceI18nNamespace(resource);
  return namespace === ns;
};

const resources = (
  Object.keys(ResourceEnum) as Array<keyof typeof ResourceEnum>
).map((key) => ResourceEnum[key]);

export const resource: NamespaceTester = (ns: string, lang: string) => {
  const resource = resources.find(isResourceTranslation(ns));

  if (resource) {
    const modules = getAllModulesIds();
    const lists = import.meta.glob(
      "../../../admin/modules/*/translations/**/*.json",
    );
    for (let i = 0; i < modules.length; i++) {
      const moduleId = modules[i];
      const relatePath = `../../../admin/modules/${moduleId}/translations/${resource}/${lang}.json`;

      if (lists[relatePath]) {
        return `src/admin/modules/${moduleId}/translations/${resource}/${lang}.json`;
      }
    }
  }
};
